import { useMemo } from 'react';

import { ConfidentialityConfiguration } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { FormContextValues, useFormController } from '@dreryk/react-common';
import { InteractiveTable, Notification, NotificationType, StyledFlex } from '@dreryk/react-components';

import { generalSettingsTranslationKeys } from '../../../../translations';

import { useConfidentialityEditModalColumns } from './ConfidentialityEditModal.hooks';
import { ConfidentialityEditModalBean, ConfidentialityEditModalRow } from './ConfidentialityEditModal.types';
import { formInitializer } from './ConfidentialityEditModal.utils';

const t = generalSettingsTranslationKeys.confidentialitySettings;

type ConfidentialityEditFormChildrenRenderProps = Pick<
   FormContextValues<ConfidentialityEditModalBean>,
   'handleSubmit'
> & {
   isDirty: boolean;
};

type ConfidentialityEditFormProps = {
   confidentialityConfiguration: ConfidentialityConfiguration;
   children: (renderProps: ConfidentialityEditFormChildrenRenderProps) => JSX.Element;
};

export const ConfidentialityEditForm = (props: ConfidentialityEditFormProps): JSX.Element => {
   const initializer = useMemo(() => formInitializer(props.confidentialityConfiguration), [
      props.confidentialityConfiguration,
   ]);

   const { register, handleSubmit, formState } = useFormController<ConfidentialityEditModalBean>(
      useMemo(() => initializer(), [initializer])
   );

   const columns = useConfidentialityEditModalColumns();

   return (
      <StyledFlex direction={'column'} gap={'16px'}>
         <InteractiveTable<ConfidentialityEditModalRow, ConfidentialityEditModalBean>
            testId={'confidentialityAccessDurations'}
            name={'rows'}
            register={register}
            columns={columns}
         />
         <Notification testId={'confidentialityEditHint'} type={NotificationType.INFO} label={t.modal.hint} />
         {props.children({ handleSubmit: handleSubmit, isDirty: formState.isDirty })}
      </StyledFlex>
   );
};
